import { render, staticRenderFns } from "./TownshipGroup.vue?vue&type=template&id=140df52d&scoped=true&"
import script from "./TownshipGroup.vue?vue&type=script&lang=js&"
export * from "./TownshipGroup.vue?vue&type=script&lang=js&"
import style0 from "./TownshipGroup.vue?vue&type=style&index=0&id=140df52d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140df52d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VRow})
